define( 'bootstrap',[ 'jquery', 'component', 'helper', 'breakpoint', 'form', 'journey', 'lib/utils', 'format-numbers' ],
	function ( $, component, helper, breakpoint, Form, journey, utils, formatNumbers ) {

		'use strict';

		/**
		 * Application entry point: Initialises all components and implements any other global behaviours.
		 * @module
		 */

		// add js classname to html tag
		document.getElementsByTagName( 'html' )[ 0 ].className = 'js';

		// initialise breakpoints
		breakpoint.init();

		// initialise components
		component.init();

		// initialise helpers
		helper.init();

		// initialise forms
		$( '[data-form]' ).each( function () {
			( new Form( $( this ) ) ).init();
		} );

		// initialise journeys
		journey.init();

		// init auto currency formatting
		formatNumbers.init();

		// disable tel links in IE
		if ( utils.isMSIE() ) {

			$( 'a[href^=tel]' ).each( function () {

				var $link = $( this );
				$link.addClass( 'link--inactive-tel' );
				$link.on( 'click', function ( e ) {
					e.preventDefault();
				} );
			} );
		}

		// init re-rendered components
		window.initComponents = function ( id ) {

			var $components,
				$helpers,
				$journeys,
				$newInitBlock;

			// prevent calling anything again if no id is passed
			if ( typeof ( id ) !== 'undefined' ) {

				$newInitBlock = $( '#' + id );

				$components = $newInitBlock.find( '[ data-component ]' );
				$helpers = $newInitBlock.find( '[ data-helper ]' );
				$journeys = $newInitBlock.find( '[ data-journey ]' );

				component.init( $components );
				helper.init( $helpers );
				journey.init( $journeys );

			}
		};

	} );

